import { Box, BoxProps } from "@chakra-ui/react";

function CircularEnglishIcon({ ...props }: BoxProps) {
  return (
    <Box cursor={"pointer"} {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="19"
          height="19"
          rx="9.5"
          stroke="#18191B"
        />
        <path
          d="M4.43799 13.6679V6.32812H8.66359V7.10916H5.36922V9.41221H8.1429V10.2033H5.36922V12.8868H8.77374V13.6679H4.43799Z"
          fill="#18191B"
        />
        <path
          d="M10.3345 13.6679V6.32812H11.2857L13.9593 10.9543L14.7503 12.4763H14.8004C14.7403 11.7353 14.6702 10.9042 14.6702 10.1432V6.32812H15.5614V13.6679H14.6001L11.9366 9.04172L11.1456 7.52972H11.0955C11.1456 8.2707 11.2156 9.04172 11.2156 9.82276V13.6679H10.3345Z"
          fill="#18191B"
        />
      </svg>
    </Box>
  );
}

export { CircularEnglishIcon };
